import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const getMembers = async (setData, name, page, size) => {
  return await axios.get(`members/search-page?name=${encodeURIComponent(name)}&page=${page}&size=${size}`)
    .then((response) => {
      setData(response.data.data);
    })
    .catch(() => {});
};

export default getMembers;